import { useState } from 'react';
import { trpc } from '@client-trpc';
import { UserCreateInput } from '@server/users/schemas/inputs.schema';
import { UNKNOWN_ERROR_MESSAGE } from '../../foundation/notifications/errors';
import { useAuth } from './auth.hook';

const useLogin = () => {
  const [error, setError] = useState<string>();
  const utils = trpc.useUtils();
  const { setAuthenticated } = useAuth();

  const { mutateAsync: loginMutation } = trpc.auth.login.useMutation({
    onSuccess: (data) => {
      if (data.accessToken) {
        localStorage.setItem('accessToken', data.accessToken);
        // Full reload to ensure TRPC WS reconnects with fresh token
        window.location.reload();
      }
      setError('');
      setAuthenticated(true);
      utils.auth.getCurrentUser.invalidate();
    },
    onError: (error) => {
      if (error.data?.code === 'UNAUTHORIZED') {
        setError('Credentials are not valid.');
      } else {
        setError(error.message || UNKNOWN_ERROR_MESSAGE);
      }
    }
  });

  const login = async (request: UserCreateInput) => {
    await loginMutation(request);
  };

  return { login, error };
};

export { useLogin };
